import { useContext, useEffect } from "react";
import { UNSAFE_DataRouterContext, useBlocker } from "react-router-dom";

export interface PendingAnnotationNavigation {
  proceed: () => void;
  reset: () => void;
}

function RouterGuard({
  dirty,
  onBlocked,
}: {
  dirty: boolean;
  onBlocked: (navigation: PendingAnnotationNavigation) => void;
}) {
  const blocker = useBlocker(dirty);
  useEffect(() => {
    if (blocker.state === "blocked") onBlocked(blocker);
  }, [blocker, onBlocked]);
  return null;
}

/** The production app uses a data router. Keep the standalone gallery and
 * legacy entrypoints usable too; those still receive the beforeunload guard. */
export function AnnotationNavigationGuard(props: {
  dirty: boolean;
  onBlocked: (navigation: PendingAnnotationNavigation) => void;
}) {
  const router = useContext(UNSAFE_DataRouterContext);
  return router ? <RouterGuard {...props} /> : null;
}
